import React from "react";
import Helmet from "react-helmet";
import Jumbotron from "react-bootstrap/Jumbotron";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./legal.styles.scss";

export default function Policies() {
  return (
    <>
      <Helmet>
        <title>Políticas - Prominox</title>
        <meta
          name="description"
          content="Consulta nuestras políticas ambientales, de calidad, de privacidad y de devolución en Prominox."
        />
      </Helmet>
      <section className="hero--legal">
        <Jumbotron fluid className="jumbotron--legal"></Jumbotron>
      </section>
      <section className="legal__info">
        <Container>
          <h1 className="text-center">Políticas</h1>
          
          <Row className="mb-5">
            <Col md={6} className="mb-4">
              <h2 className="legal__info__sub-heading">Política Ambiental</h2>
              <div style={{textAlign: 'center'}}>
                <a
                  href={require("../../assets/Politica ambiental CS 2022 Vertical.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{display: 'inline-block'}}
                >
                  <img
                    src={require("../../assets/Politica ambiental CS 2022 Vertical.png")}
                    alt="Política Ambiental"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      ':hover': {
                        transform: 'scale(1.02)'
                      }
                    }}
                  />
                  <p style={{marginTop: '1rem', color: '#666'}}>
                    Haz clic en la imagen para ver el documento completo
                  </p>
                </a>
              </div>
            </Col>

            <Col md={6} className="mb-4">
              <h2 className="legal__info__sub-heading">Política de Calidad</h2>
              <div style={{textAlign: 'center'}}>
                <a
                  href={require("../../assets/Políticas de calidad.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{display: 'inline-block'}}
                >
                  <img
                    src={require("../../assets/Políticas de calidad-1.png")}
                    alt="Política de Calidad"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      ':hover': {
                        transform: 'scale(1.02)'
                      }
                    }}
                  />
                  <p style={{marginTop: '1rem', color: '#666'}}>
                    Haz clic en la imagen para ver el documento completo
                  </p>
                </a>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-4">
              <h2 className="legal__info__sub-heading">Aviso de Privacidad</h2>
              <div style={{textAlign: 'center'}}>
                <a
                  href={require("../../assets/Aviso de Privacidad.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{display: 'inline-block'}}
                >
                  <img
                    src={require("../../assets/Aviso de Privacidad-1.png")}
                    alt="Aviso de Privacidad"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      ':hover': {
                        transform: 'scale(1.02)'
                      }
                    }}
                  />
                  <p style={{marginTop: '1rem', color: '#666'}}>
                    Haz clic en la imagen para ver el documento completo
                  </p>
                </a>
              </div>
            </Col>

            <Col md={6} className="mb-4">
              <h2 className="legal__info__sub-heading">Política de Reclamaciones</h2>
              <div style={{textAlign: 'center'}}>
                <a
                  href={require("../../assets/Política reclamaciones.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{display: 'inline-block'}}
                >
                  <img
                    src={require("../../assets/Política reclamaciones-1.png")}
                    alt="Política de Reclamaciones"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      border: '1px solid #eee',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      ':hover': {
                        transform: 'scale(1.02)'
                      }
                    }}
                  />
                  <p style={{marginTop: '1rem', color: '#666'}}>
                    Haz clic en la imagen para ver el documento completo
                  </p>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
} 